import { isFunction } from 'lodash';

/**
 * Similar to lodash's pull function, but compatible with Vue's way of observing arrays. Only pulls the first value.
 * @param array
 * @param value
 */
export function pull (array, value) {
  const ix = array.indexOf(value);
  if (ix > -1) {
    array.splice(ix, 1);
  }
  return array;
}

/**
 * Ensures a value is not added to an array more than once.
 * @param array
 * @param compareDelegate
 * @param values
 */
export function pushOnce (array, compareDelegate, ...values) {
  let compareFn = (a) => (b) => a === b;

  // If a compare delegate is supplied use it to compare values; otherwise it's just another value to be compared.
  if (isFunction(compareDelegate)) {
    compareFn = compareDelegate;
  } else {
    values.push(compareDelegate);
  }

  // Now just push each unique value into the array.
  values.forEach(v => {
    if (!array.find(compareFn(v))) {
      array.push(v);
    }
  });

  return array;
}

// These delegates can be used to filter items from an array
export const filterNone = () => true;
export const filterEven = (v, index) => index % 2;
export const filterOdd = (v, index) => !(index % 2);



// WEBPACK FOOTER //
// ./src/shared/util/array.js